import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";
import path from "path";

const BookingList = Loadable(
  lazy(() =>
    import("./bookingList").then(({ BookingList }) => ({
      default: BookingList,
    }))
  )
);

export const bookingRoutes = [
  {
    path: "/bookings",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.BOOKING]}>
        <BookingList />
      </AuthorizedRoute>
    ),
  },
  // {
  // 	path: "/customer-overview/:id",
  // 	exact: true,
  // 	element: (
  // 		<AuthorizedRoute

  // 			moduleIds={[ALLOWED_MODULES.CUSTOMER]}
  // 		>
  // 			<CustomerOverview />
  // 		</AuthorizedRoute>
  // 	),
  // },
  // {
  // 	path: "/edit-customer/:id",
  // 	exact: true,
  // 	element: (
  // 		<AuthorizedRoute

  // 			moduleIds={[ALLOWED_MODULES.CUSTOMER]}
  // 		>
  // 			<EditCustomer />
  // 		</AuthorizedRoute>
  // 	),
  // },
];
